<template>

<fragment>

    <core-card-head-ratings>

        <core-rating :value="userValue" type="rating" tooltip="User Rating" class="card-rating" v-if="showUserRating" />
        <core-rating :value="groupValue" :count="groupCount" type="rating" tooltip="Group Rating" class="card-rating" v-if="field.group_rating === 'enabled'" />
        <core-rating :value="communityValue" :count="communityCount" tooltip="BGG Rating" class="card-rating" v-if="field.bgg_rating === 'enabled'" />

    </core-card-head-ratings>

</fragment>

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		userValue: function() {

			return this.item.user.rating_avg

		},

		communityValue: function() {

			return this.item.game.rating_avg

		},

		communityCount: function() {

			return this.item.game.rating_count

		},

		groupValue: function() {

			return this.item.group.rating_avg

		},

		groupCount: function() {

			return this.item.group.rating_count

		},

		showUserRating: function() {

			return this.field.user_rating === 'enabled' && (this.isUser || this.isBuddies || (this.isGroup && this.isMember))

		}

	}

}

</script>

<style scoped>

.card-rating {
	width: 64px;
	height: 64px;
	line-height: 64px;
	font-size: 0;
	flex-shrink: 0;
	cursor: initial;
	color: #fff;
    margin-right: 2px;
    font-size: 24px;
    font-weight: 500;
}

</style>